import { SideBarCategory, SideBarInnerCategory, SideBarSubCategory } from "components"
import arrow_icon from "./selecticon.png"

import { useFetchDeviceQuery } from "../../store/Features/devices/devices-api-slice"

import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "theme-ui"
import "./style/style.css"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import { IDeviceTreeGroupElement, IDeviceGroup, IDeviceTree, ISelectedDeviceIds } from "@types"
import { compareNumber, compareDeviceGroupElements } from "utils/assert"

import { setSelectedDeviceIds } from "../../store/Slices/selectedDeviceIds"

import HideIcon from "./hide-menu-icon.png"
import { hide } from "../../store/Slices/sidebar-hide"

import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { distinctArrayOfDeviceTreeGroupElements } from "utils/distinct"
import { useSelector } from "react-redux"

export const SideBar = () => {
 const location = useLocation()

 const queryParams = new URLSearchParams(location.search)
 const selectedDeviceIds: ISelectedDeviceIds = useSelector((state: any) => state.selectedDevicesIds)
 const deviceId = queryParams.get("deviceId")
 const dispatch = useDispatch()
 const { data, isLoading } = useFetchDeviceQuery()

 const handleClose = () => {
  dispatch(hide())

  // Dispatch the hide action
 }

 // language translator
 const { t } = useTranslation("translation")

 // state for open All
 const [openAllDevices, setOpenAllDevices] = useState<boolean>(false)

 // State for Open Server list
 const [openServerList, setOpenServerList] = useState<number[]>([])

 // State for Open Device group List
 const [openDeviceGroup, setOpenDeviceGroup] = useState<number[]>([])

 // state for Selected Devices
 const [selectedDeviceTreeGroupElements, setSelectedDeviceTreeGroupElements] = useState<
  IDeviceTreeGroupElement[]
 >([])

 const restructuredData: IDeviceTree[] = data
  ? data.map((server: IDeviceTree) => ({
     ...server,
     device_groups: server.device_groups.map((deviceGroup: IDeviceGroup) => ({
      ...deviceGroup,
      server_id: server.server_id,
      devices: distinctArrayOfDeviceTreeGroupElements(deviceGroup.devices).map(
       (device: IDeviceTreeGroupElement) => ({
        ...device,
        group_id: deviceGroup.group_id,
        server_id: server.server_id,
       }),
      ),
     })),
    }))
  : []

 const allDevices: IDeviceTreeGroupElement[] = restructuredData
  ? restructuredData
     .map((server: IDeviceTree) =>
      server.device_groups.map((deviceGroup: IDeviceGroup) =>
       deviceGroup.devices.map((device: IDeviceTreeGroupElement) => device),
      ),
     )
     .flat()
     .flat()
  : []

 useEffect(() => {
  if (data && deviceId) {
   setSelectedDeviceTreeGroupElements([
    ...allDevices.filter((device: IDeviceTreeGroupElement) => deviceId.includes(device.device_id)),
   ])
  } else if (data) {
   setSelectedDeviceTreeGroupElements([
    ...allDevices.filter((device: IDeviceTreeGroupElement) =>
     selectedDeviceIds.deviceIds.includes(device.device_id),
    ),
   ])
  }
  // eslint-disable-next-line
 }, [data])
 const reqHandlerForSelectedDevices = () => {
  const deviceIds = selectedDeviceTreeGroupElements.map(
   (device: IDeviceTreeGroupElement) => device.device_id,
  )

  dispatch(setSelectedDeviceIds({ deviceIds: deviceIds }))
 }

 useEffect(() => {
  if (!isLoading) reqHandlerForSelectedDevices()
  // eslint-disable-next-line
 }, [selectedDeviceTreeGroupElements])

 const handleCheckOpenAllDevices = (allOpenServers: number[], allOpenGroups: number[]) => {
  const serverList: number[] | undefined = []
  const deviceGroups: number[] | undefined = []

  restructuredData?.forEach((server: IDeviceTree) => {
   serverList.push(server.server_id)
   server.device_groups.forEach((deviceGroup: IDeviceGroup) => {
    deviceGroups?.push(deviceGroup.group_id)
   })
  })
  if (compareNumber(serverList, allOpenServers) && compareNumber(deviceGroups, allOpenGroups)) {
   setOpenAllDevices(true)
  }
 }

 // toggle open All
 const toggleOpenAll = () => {
  if (!openAllDevices) {
   const serverList: number[] | undefined = []
   const deviceGroups: number[] | undefined = []

   restructuredData?.forEach((server: IDeviceTree) => {
    serverList.push(server.server_id)
    server.device_groups.forEach((deviceGroup: IDeviceGroup) => {
     deviceGroups?.push(deviceGroup.group_id)
    })
   })
   serverList && setOpenServerList(serverList)
   deviceGroups && setOpenDeviceGroup(deviceGroups)
  } else {
   setOpenServerList([])
   setOpenDeviceGroup([])
  }
  setOpenAllDevices(!openAllDevices)
 }

 // toggle open server
 const handleOpenServerList = (serverId: number) => {
  if (openServerList.includes(serverId)) {
   setOpenServerList(openServerList.filter((id) => id !== serverId))
  } else {
   const updatedOpenServerList = [...openServerList, serverId]
   setOpenServerList(updatedOpenServerList)
   handleCheckOpenAllDevices([...updatedOpenServerList], [...openDeviceGroup])
  }
 }

 // Toggle Open Device Group
 const toggleOpenDeviceGroup = (groupId: number) => {
  if (openDeviceGroup.includes(groupId)) {
   setOpenDeviceGroup(openDeviceGroup.filter((id: number) => id !== groupId))
  } else {
   const updatedOpenDeviceGroup = [...openDeviceGroup, groupId]
   setOpenDeviceGroup(updatedOpenDeviceGroup)
   handleCheckOpenAllDevices([...openServerList], [...updatedOpenDeviceGroup])
  }
 }

 // toggle select All
 const toggleSelectAll = () => {
  if (compareDeviceGroupElements(allDevices, selectedDeviceTreeGroupElements)) {
   setSelectedDeviceTreeGroupElements([])
  } else {
   setSelectedDeviceTreeGroupElements([...allDevices])
  }
 }

 return (
  <Box bg="highlight" color="text" className="w-full relative h-full">
   <div className="w-full">
    <div className="flex w-full justify-between  px-4 mb-4 pt-6">
     <h1 className=" font-semibold text-lg Jakarta-font">{t("Devices")}</h1>

     <button className="Jakarta-font font-semibold text-sm" type="button" onClick={handleClose}>
      <img width={35} src={HideIcon} alt="hide-menu" />
     </button>
    </div>
   </div>
   <div className="w-full">
    {isLoading ? (
     <div className="w-[90%] mt-8 device-loader mx-auto">
      <Skeleton className="py-1 my-1 w-full" count={3} />
     </div>
    ) : (
     <div>
      <div className="flex gap-2 py-4 rounded w-11/12 mx-auto">
       <div
        onClick={() => toggleOpenAll()}
        className="bg-golden h-6 w-6 rounded border-yellow border flex justify-center items-center cursor-pointer"
       >
        <img
         className={` ${openAllDevices ? "rotate-360" : "rotate-180"}`}
         src={arrow_icon}
         alt="selectIcon"
         loading="lazy"
        />
       </div>
       <Box color="text">
        {!compareDeviceGroupElements(allDevices, selectedDeviceTreeGroupElements) &&
        selectedDeviceTreeGroupElements.length ? (
         <div className="flex gap-2">
          <span
           className="bg-golden h-[24px] w-[22px] rounded border-yellow border flex justify-center items-center cursor-pointer"
           onClick={() => {
            toggleSelectAll()
           }}
          >
           <div className="w-[8px] h-[2px] bg-black"></div>
          </span>
          <label className="font-semibold font-sm Jakarta-font">{t("allDevices")}</label>
         </div>
        ) : (
         <div className="custom-checkbox">
          <input
           className="bg-golden"
           //  method to select/unselect all
           onChange={() => {
            toggleSelectAll()
           }}
           type="checkbox"
           checked={compareDeviceGroupElements(allDevices, selectedDeviceTreeGroupElements)}
           id="allDevices"
          />
          <label className="font-semibold font-sm Jakarta-font" htmlFor="allDevices">
           {t("allDevices")}
          </label>
         </div>
        )}
       </Box>
      </div>{" "}
      {restructuredData?.map((server: IDeviceTree, index: number) => (
       <div key={index}>
        {/* ======  SideBar for servers/device-tree  ===== */}

        <SideBarCategory
         server={server}
         handleOpenServerList={handleOpenServerList}
         openServerList={openServerList}
         setSelectedDeviceTreeGroupElements={setSelectedDeviceTreeGroupElements}
         selectedDeviceTreeGroupElements={selectedDeviceTreeGroupElements}
        />

        {openServerList.includes(server.server_id) && (
         <ul>
          {server.device_groups.map((group: IDeviceGroup, groupIndex: number) => (
           <div key={groupIndex}>
            <li>
             {/* ======  SideBar For DeviceGroup  ===== */}
             <SideBarSubCategory
              group={group}
              openDeviceGroup={openDeviceGroup}
              toggleOpenDeviceGroup={toggleOpenDeviceGroup}
              setSelectedDeviceTreeGroupElements={setSelectedDeviceTreeGroupElements}
              selectedDeviceTreeGroupElements={selectedDeviceTreeGroupElements}
             />
            </li>
            {openDeviceGroup.includes(group.group_id) && (
             <li>
              {/* =====  SideBar Devices ====== */}
              <SideBarInnerCategory
               group={group}
               setSelectedDeviceTreeGroupElements={setSelectedDeviceTreeGroupElements}
               selectedDeviceTreeGroupElements={selectedDeviceTreeGroupElements}
              />
             </li>
            )}
           </div>
          ))}
         </ul>
        )}
       </div>
      ))}
     </div>
    )}
   </div>
  </Box>
 )
}
